import { useResponsiveness } from '../../responsiveness/useResponsiveness';
import { Header } from '../Header/Header';
import { ViewContainer } from '../ViewContainer/ViewContainer';
import { LayoutType } from '../../types';
import { BackButtonWrapper, ViewContainerWrapper } from './LayoutTemplate.styles';
import { BackLink } from '../BackLink/BackLink';
import { ManageCookies } from '../ManageCookies/ManageCookies';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const LayoutTemplate = ({
  layoutType = LayoutType.CentredStep,
  showBackLink = false,
  showHaveAnAccountLink = false,
  showLogo = false,
  showProgressIndicator = false,
  showStepProgressIndicator = false,
  stepIndex,
  stepNames,
  totalSteps,
  currentStepNumber,
  accountLinkMessage,
  logoAltText,
  logoImageSrc,
  logoWidth,
  logoHeight,
  backLinkHref,
  accountLinkHref,
  onBackLinkClick,
  onAccountLinkClick,
  onLogoClick,
  children,
  messagingContent,
  alignCentredStepAtTheTop,
  showManageCookiesLink = false,
  shouldLogoBeClickable = true,
  shouldHalveProgressBar = false,
  shouldAddTopPadding = true,
  titleContainer,
  decorativeBgComponent
}) => {
  const {
    isMobile,
    isDesktop
  } = useResponsiveness();
  const shouldShowBackLink = layoutType !== LayoutType.FramedCentredModalStep && !isMobile && showBackLink;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ViewContainerWrapper, {
      layoutType: layoutType,
      children: [/*#__PURE__*/_jsx(Header, {
        totalSteps: totalSteps,
        currentStepNumber: currentStepNumber,
        showProgressIndicator: showProgressIndicator,
        showStepProgressIndicator: showStepProgressIndicator,
        showLogo: showLogo,
        showHaveAnAccountLink: showHaveAnAccountLink,
        shouldHalveProgressBar: shouldHalveProgressBar,
        accountLinkMessage: accountLinkMessage,
        logoAltText: logoAltText,
        logoImageSrc: logoImageSrc,
        logoWidth: logoWidth,
        logoHeight: logoHeight,
        accountLinkHref: accountLinkHref,
        showBackLink: showBackLink,
        onAccountLinkClick: onAccountLinkClick,
        onLogoClick: onLogoClick,
        onBackLinkClick: onBackLinkClick,
        shouldLogoBeClickable: shouldLogoBeClickable,
        stepIndex: stepIndex,
        stepNames: stepNames
      }), shouldShowBackLink && /*#__PURE__*/_jsx(BackButtonWrapper, {
        children: /*#__PURE__*/_jsx(BackLink, {
          href: backLinkHref,
          onClick: onBackLinkClick
        })
      }), /*#__PURE__*/_jsx(ViewContainer, {
        alignCentredStepAtTheTop: alignCentredStepAtTheTop,
        shouldAddTopPadding: shouldAddTopPadding,
        showBackLink: showBackLink,
        showMobileView: isMobile,
        layoutType: layoutType,
        decorativeBgComponent: decorativeBgComponent,
        messagingChildren: messagingContent,
        backLinkHref: backLinkHref,
        onBackLinkClick: onBackLinkClick,
        showManageCookiesLink: showManageCookiesLink,
        titleContainer: titleContainer,
        children: children
      })]
    }), isDesktop && showManageCookiesLink && /*#__PURE__*/_jsx(ManageCookies, {})]
  });
};